/** @jsxImportSource @emotion/react */
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  ACTION_ACCEPT,
  ACTION_APPROVE,
  ACTION_CANCEL,
  ACTION_CANCEL_ACCEPT,
  ACTION_CANCEL_APPROVE,
  ACTION_CANCEL_DECLINE,
  ACTION_CANCEL_OFFER,
  ACTION_CANCEL_REFUSE,
  ACTION_DECLINE,
  ACTION_REFUSE,
  ACTION_REINSTATE,
  ACTION_RETRACT,
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_CANCEL_OFFERED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_DECLINED,
  STATUS_EXPIRED_ADM,
  STATUS_EXPIRED_EE,
  STATUS_OFFERED,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
} from "../util/constants.js";
import TradeFormActionCheckDialog from "./TradeFormActionCheckDialog.jsx";
import ActionButton from "./fundamentals/ActionButton.jsx";

export class TradeFormAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActionCheckDialogOpen: false,
      actionSelected: "",
    };
  }

  getOfferedStatusActionsBasedOnLoggedInEmployee() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return (
        // <Grid container>
        //   <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_RETRACT)}
            >
              {ACTION_RETRACT}
            </ActionButton>
        //   </Grid>
        // </Grid>
      );
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_ACCEPT)}
            >
              {ACTION_ACCEPT}
            </ActionButton>
          </Grid>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_DECLINE)}
            >
              {ACTION_DECLINE}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else {
      return "we broke";
    }
  }

  getSubmittedStatusActionsBasedOnLoggedInEmployee() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_APPROVE)}
            >
              {ACTION_APPROVE}
            </ActionButton>
          </Grid>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_REFUSE)}
            >
              {ACTION_REFUSE}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getDeclinedStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getRetractedStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getApprovedStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL)}
            >
              {ACTION_CANCEL}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL_OFFER)}
            >
              {ACTION_CANCEL}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL_OFFER)}
            >
              {ACTION_CANCEL}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else {
      return "we broke";
    }
  }

  getRefusedStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getCancelOfferedStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL)}
            >
              {ACTION_CANCEL}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else if (this.props.loggedInUserData.eid === this.props.trade.modifiedByEid) {
      // Cancel offering employee
      return <div></div>;
    } else if (this.props.loggedInUserData.eid !== this.props.trade.modifiedByEid) {
      // Cancel offer receiving employee
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL_ACCEPT)}
            >
              {ACTION_ACCEPT}
            </ActionButton>
          </Grid>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL_DECLINE)}
            >
              {ACTION_DECLINE}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else {
      return "we broke";
    }
  }

  getCancelSubmittedStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL_APPROVE)}
            >
              {ACTION_APPROVE}
            </ActionButton>
          </Grid>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_CANCEL_REFUSE)}
            >
              {ACTION_REFUSE}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getCanceledStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getExpiredEEStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getExpiredADMStatusActionsBasedOnLoggedInEmployees() {
    if (this.props.loggedInUserData.isAdmin && this.props.isAdminPage) {
      // Admin
      return (
        <Grid container>
          <Grid item xs={6} md={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={this.handleActionClicked.bind(this, ACTION_REINSTATE)}
            >
              {ACTION_REINSTATE}
            </ActionButton>
          </Grid>
        </Grid>
      );
    } else if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      // Employee #1
      return <div></div>;
    } else if (this.props.loggedInUserData.eid === this.props.trade.requestedEmployeeId) {
      // Employee #2
      return <div></div>;
    } else {
      return "we broke";
    }
  }

  getActionsBasedOnStatusAndLoggedInEmployee(status) {
    switch (status) {
      case STATUS_OFFERED:
        return this.getOfferedStatusActionsBasedOnLoggedInEmployee();
      case STATUS_SUBMITTED:
        return this.getSubmittedStatusActionsBasedOnLoggedInEmployee();
      case STATUS_DECLINED:
        return this.getDeclinedStatusActionsBasedOnLoggedInEmployees();
      case STATUS_RETRACTED:
        return this.getRetractedStatusActionsBasedOnLoggedInEmployees();
      case STATUS_APPROVED:
        return this.getApprovedStatusActionsBasedOnLoggedInEmployees();
      case STATUS_REFUSED:
        return this.getRefusedStatusActionsBasedOnLoggedInEmployees();
      case STATUS_CANCEL_OFFERED:
        return this.getCancelOfferedStatusActionsBasedOnLoggedInEmployees();
      case STATUS_CANCEL_SUBMITTED:
        return this.getCancelSubmittedStatusActionsBasedOnLoggedInEmployees();
      case STATUS_CANCELED_EE:
        return this.getCanceledStatusActionsBasedOnLoggedInEmployees();
      case STATUS_CANCELED_ADM:
        return this.getCanceledStatusActionsBasedOnLoggedInEmployees();
      case STATUS_EXPIRED_EE:
        return this.getExpiredEEStatusActionsBasedOnLoggedInEmployees();
      case STATUS_EXPIRED_ADM:
        return this.getExpiredADMStatusActionsBasedOnLoggedInEmployees();
      default:
        return "uh oh";
    }
  }

  handleActionClicked(actionName) {
    this.setState({ actionSelected: actionName });
    this.handleClickDialogOpen();
  }

  handleClickDialogOpen() {
    this.setState({ isActionCheckDialogOpen: true });
  }

  handleClickDialogClose(event, reason) {
    if (reason && reason === "backdropClick") return;
    this.setState({ isActionCheckDialogOpen: false });
  }

  render() {
    return (
      <Grid
        sx={{
          lineHeight: "normal",
          textAlign: "left",
        }}
        data-testid="trade-form-action"
      >
        {this.getActionsBasedOnStatusAndLoggedInEmployee(
          this.props.isAdminPage ? this.props.trade.visibleTradeStatusAdmin : this.props.trade.visibleTradeStatus
        )}
        <TradeFormActionCheckDialog
          loggedInUserData={this.props.loggedInUserData}
          trade={this.props.trade}
          isDialogOpen={this.state.isActionCheckDialogOpen}
          actionSelected={this.state.actionSelected}
          onClickDialogOpen={this.handleClickDialogOpen.bind(this)}
          onClickDialogClose={this.handleClickDialogClose.bind(this)}
          onTradeDialogClose={this.props.onTradeDialogClose ? this.props.onTradeDialogClose.bind(this) : null}
          isAdminPage={this.props.isAdminPage}
        />
      </Grid>
    );
  }
}

TradeFormAction.propTypes = {
  isAdminPage: PropTypes.bool.isRequired,
  trade: PropTypes.object.isRequired,
  loggedInUserData: PropTypes.object.isRequired,
  onTradeDialogClose: PropTypes.func,
};

export default TradeFormAction;
